import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SettingsService } from '../../_services/settings.service';
import { capitalizeFirstLetter } from '../../_utils/general-utils';

@Component({
    selector: 'app-termos-uso', templateUrl: './termos-uso.component.html', styleUrls: ['./termos-uso.component.css'],
    standalone: false
})
export class TermosUsoComponent implements OnInit {
    src: string;

    constructor(private settingsService: SettingsService, private route: Router) { }

    ngOnInit(): void {
        let rotas = this.route.url.split('/');
        let tipo = capitalizeFirstLetter(rotas[rotas.length - 1]);
        let document = rotas[rotas.length - 2];

        const documentMap: { [key: string]: string } = {
            'termos-uso': 'Termos_de_Uso',
            'politica-privacidade': 'Politica_de_Privacidade',
            'politica-cookies': 'Politica_de_Cookies'
        };

        let documentName = documentMap[document];

        this.settingsService.getTermosUsoVersion().subscribe({
            next: (response) => {
                let versao = tipo === 'comprador' ? response.comprador : response.vendedor;

                this.src = `${this.settingsService.pathLegalDocumentsPartsfy}${versao}/${documentName}_${tipo}_Partsfy.pdf`;
            },
            error: () => {
                this.src = `${this.settingsService.pathLegalDocumentsPartsfy}/v1/${documentName}_${tipo}_Partsfy.pdf`;
            }
        })
    }
}
